import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './Hero.css'


var Hero = BaseView.extend({
    events: {
        'click .Hero-btn': 'scrollDown'
    },

    initialize () {
        this.$frame = this.$('.Frame')

        this.$arrow = this.$('.Hero-btn')
        this.$title = this.$('.Hero-title')
        this.$img = this.$('.Hero-img')

        this._arrowShownBinded = this._arrowshown.bind(this)
    },

    activateFrame () {
        return new Promise(
            (resolve) => {
                setTimeout(() => {
                    this.$frame.addClass('isActive')

                    resolve()
                }, 250)
            }
        )
    },

    activateArrow() {
        this.$arrow[0].addEventListener('transitionend', this._arrowShownBinded)
        this.$arrow[0].addEventListener('webkitTransitionEnd', this._arrowShownBinded)

        this.$arrow.removeClass('isNotActive isNotTransitioned')
    },

    deactivateArrow() {
        this.$arrow.addClass('isNotActive')
    },

    _arrowshown() {
        this.$arrow.addClass('isActive')
    },

    activateTitle (options) {
        var self = this

        return $.Velocity.animate(this.$title[0], {opacity: 1}, _.extend({
            duration: 1500,
            complete () {
                self.$title.removeClass('isNotActive')
            }
        }, options))
    },

    deactivateTitle(options) {
        return $.Velocity.animate(this.$title[0], {opacity: 0}, _.extend({duration: 1000}, options))
    },


    activateImage (options) {
        return $.Velocity.animate(this.$img[0], {opacity: 1}, _.extend({duration: 1500}, options))
    },

    deactivateImage (options) {
        return $.Velocity.animate(this.$img[0], {opacity: 0}, _.extend({duration: 500}, options))
    },

    scrollDown(options) {
        this.deactivateArrow()

        app.els.$htmlBody.velocity('scroll', _.extend({
            offset: app.els.$window.height(),
            duration: 800,
            easing: 'easeInQuad'
        }, options))
    }
})

export default Hero


// WEBPACK FOOTER //
// ./assets/app/front/components/Hero/Hero.js